import styled from "styled-components";

// Paleta consistente: Preto, Branco e Dourado
const theme = {
  bg: '#121212',
  surface: '#1E1E1E',
  gold: '#D4AF37',
  goldHover: '#EACD65',
  text: '#FFFFFF',
  textSecondary: '#A9A9A9',
  border: '#333333',
};

export const ExtratoContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    background-color: ${theme.bg};
    /* Mantive sua imagem de fundo */
    background-image: url('textura.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed; /* Imagem fica parada ao rolar a página */
    box-sizing: border-box;
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    @media (max-width: 768px){
        padding: 1rem;
    }
`;

export const MainCard = styled.div`
    width: 100%;
    max-width: 1200px;
    background-color: ${theme.surface};
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    border: 1px solid ${theme.border};
    z-index: 2;

    @media (max-width: 768px){
        padding: 1.5rem;
    }
`;

export const Header = styled.header`
    text-align: left;
    margin-bottom: 2rem;
    border-bottom: 1px solid ${theme.border};
    padding-bottom: 1.5rem;
`;

export const Title = styled.h1`
    font-size: 2rem;
    color: ${theme.text};
    margin: 0 0 0.5rem 0;
`;

export const Subtitle = styled.p`
    font-size: 1rem;
    color: ${theme.textSecondary};
    margin: 0;
`;

export const FilterContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap; /* Permite que os botões quebrem a linha no mobile */
`;

export const FilterButton = styled.button`
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: ${theme.textSecondary};
    background-color: transparent;
    border: 1px solid ${theme.border};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background-color: ${theme.gold};
        color: ${theme.surface};
        border-color: ${theme.gold};
    }

    &.active {
        background-color: ${theme.gold};
        color: ${theme.surface};
        border-color: ${theme.gold};
        box-shadow: 0 0 15px rgba(212, 175, 55, 0.2);
    }
`;

// Estilos que não são mais necessários foram removidos para limpeza.
// Mantendo apenas o essencial:

export const LoadBox = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: ${theme.bg};
`;

// A logo no fundo, se quiser usar, pode ser estilizada assim:
export const LoginBehind = styled.img`
    position: fixed;
    width: 350px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    opacity: 0.05;
    pointer-events: none; /* Impede que a imagem atrapalhe cliques */
`;